import { Component, inject, OnInit } from '@angular/core';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { VisaReportService } from '../../services/visa-report.service';
import { ToastrService } from 'ngx-toastr';
import { batch } from '../ship-reports/batch.interface';
import { EntitlementService } from 'src/app/services/entitlement.service';
import { MessageService } from '../../services/message.service';
import { formatDate } from '@angular/common';
import { ShipReportService } from '../../services/ship-report.service';

@Component({
  selector: 'visa-ship-reports',
  templateUrl: './visa-reports.component.html',
  styleUrls: ['./visa-reports.component.css']
})
export class VisaReportsComponent implements OnInit {
  locations = [];
  location: any;
  report: any;
  startDate: NgbDate;
  endDate: NgbDate;
  batch: batch;
  transactions = [];
  text: string;
  spinner = false;
  loading = false;
  shipReports = [];
  dateChanged = false;
  trans : { startDate : string }

  constructor(
    private calendar: NgbCalendar,
    private visaReportService: VisaReportService,
    private messageService: MessageService,
    private toastrService: ToastrService,
    private entitlementService: EntitlementService,
    private shipReportService: ShipReportService
  ) {}

  ngOnInit() {
  }

  searchTransactions() {
    this.spinner = true;
    this.trans = {
      startDate:
        this.startDate.month +
        '/' +
        this.startDate.day +
        '/' +
        this.startDate.year
    };
    this.visaReportService.getShipReportsByDate(this.trans).subscribe(
      (data: object[]) => {
        this.transactions = data;
        if (this.transactions.length === 0) {
          this.text = '';
        } else {
          this.text = this.transactions.length + ' report(s) found';
        }
        this.spinner = false;
      },
      (err) => {
        this.spinner = false;
        this.toastrService.error('Had an issue finding reports.');
      }
    );
  }

  showShipReportDetails(fileName: string) {
    const reportDate = new Date(this.trans.startDate);
    this.shipReportService.downloadVisaReport(formatDate(reportDate, 'yyyyMMdd', 'en-us') + '/' + fileName).subscribe(
      (response) => {
        const reportFile = new Blob([response]);
        var downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.style.display = 'none';
        downloadLink.href = URL.createObjectURL(reportFile);
        downloadLink.download = fileName;
        downloadLink.click();

        URL.revokeObjectURL(downloadLink.href);
        downloadLink.remove();
      },
      (error) => this.messageService.error(error.message)
    );
  }

  changeDate() {
    this.dateChanged = true;
    this.searchTransactions();
  }

  removeFileExtension(fileName: string): string {
    return fileName.substr(0, fileName.lastIndexOf('.'));
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

}
